<template>
  <div :class="classes">
    <div v-if="this.$slots.header || title" class="header">
      <slot name="header"><h1 class="title">{{title}}</h1></slot>
    </div>
    <div class="body">
      <slot name="body" />
    </div>
    <div v-if="this.$slots.footer" class="footer">
      <slot name="footer" />
    </div>
    <button class="close" @click="closeModal"><svg-icon class="icon" :icon="'close'" /></button>
  </div>
</template>

<script>
  import SvgIcon from '@/components/atoms/SvgIcon'

  export default {
    name: 'ModalBox',
    components: {
      SvgIcon
    },
    props: {
      size: {
        type: String,
        default: 'small',
        validator: (value) => {
          return ['medium', 'small'].includes(value) !== -1
        },
      },
      title: {
        type: String,
        default: ''
      }
    },
    computed: {
      classes() {
        const classes = [ 'modal-box', `--${this.size}` ]
        return classes
      }
    },
    methods: {
      closeModal() {
        this.$store.dispatch('closeModal')
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/_variables.scss';

  .modal-box {
    background: var(--color_bg_parts);
    border-radius: 20px;
    box-shadow: 0 0 15px rgba(0,0,0,.2);
    position: fixed;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    @include media(pc) {
      &.--small {
        width: 400px;
      }
      &.--medium {
        width: 640px;
      }
    }
    @include media(sp) {
      width: calc(100vw - 32px);
    }

  }
  .header {
    border-bottom: 1px solid $color-border;

    @include media(pc) {
      padding: 18px 0 8px;

      .title {
        font-size: 2.5rem;
        font-weight: 700;
      }
    }
    @include media(sp) {
      padding: 18px;
      .title {
        font-size: 1.7rem;
      }
    }
    .title {
      font-weight: 600;
      text-align: center;
    }
  }
  .close {
    position: absolute;
    width: 16px;
    height: 16px;
    font-size: 0;

    @include media(pc) {
      top: 30px;
      right: 24px;
    }
    @include media(sp) {
      top: 24px;
      right: 24px;
    }
    .icon {
      fill: $color-link;
    }
  }
  .body {

    @include media(pc) {
      padding: 24px 12px 40px;
    }
    @include media(sp) {
      padding: 40px 12px 48px;
    }
  }
  .footer {
    text-align: center;

    @include media(pc) {
      padding: 0 40px 40px;
    }
    @include media(sp) {
      padding: 0 32px 32px;
    }
  }
</style>